"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataBirchProps = exports.BirchHightlightGlobalStyle = void 0;
var _styledComponents = require("styled-components");
var getDataBirchProps = function getDataBirchProps(_ref, currentName) {
  var dataBirch = _ref['data-birch'];
  if (dataBirch) {
    return {
      'data-birch': dataBirch
    };
  }
  if (currentName) {
    return {
      'data-birch': currentName
    };
  }
  return {};
};
exports.getDataBirchProps = getDataBirchProps;
var BirchHightlightGlobalStyle = (0, _styledComponents.createGlobalStyle)(["[data-birch]:not(:has([data-birch])){position:relative;}[data-birch]:not(:has([data-birch]))::before{background-color:#078361;color:black;content:\"\";height:100%;left:0;opacity:0.1;pointer-events:none;position:absolute;top:0;width:100%;z-index:99999999;}[data-birch]:not(:has([data-birch]))::after{background-color:rgba(0,0,0,0.8);bottom:50%;color:white;content:attr(data-birch);font-family:'Untitled Sans',sans-serif;font-size:12px;left:50%;opacity:1;padding:8px;position:absolute;transform:translateX(-100%);transition:opacity 0.3s ease,visibility 0.3s ease;white-space:nowrap;z-index:99999999;}"]);
exports.BirchHightlightGlobalStyle = BirchHightlightGlobalStyle;